// extracted by mini-css-extract-plugin
module.exports = {"modal":"Alert-module_modal_fGFA5","body":"Alert-module_body_3JfTI","header":"Alert-module_header_1huce"};